import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
//import { actionCreators } from '../store/WeatherForecasts';
import { actionCreators } from '../store/actions/dataActions';
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Shortlist from './shortlist';
import ListShortlists from './ListShortLists';
import ShortListFromISRC from './ShortListFromISRC';
import "react-table/react-table.css";
import Select from 'react-select';
import ReadyShortlist from './ReadyShortlists';
import { CSVLink } from 'react-csv';


class Territories extends Component {

    constructor(props) {
        super(props);
        this.state = {
            codes: "",
            isrcs: "",
            selectedOption: null,
        };
     
    }
componentDidMount() {
    // This method is called when the component is first added to the document
   
    this.ensureDataFetched();
    console.info(this.props.requestedTerritoryUPC);
    console.info(this.props.requestedTerritoryType);
   
}

componentDidUpdate() {
    // This method is called when the route parameters change
    //this.ensureDataFetched();
    if (this.props.territoriesUPCS.length > 0 && !this.props.isSavingTerritory) {
        this.props.saveTerritory(this.props.territoriesUPCS[0], this.props.requestedTerritoryType);
    }
   
   
    }

   

ensureDataFetched() {
   
    // this.props.requestWeatherForecasts(startDateIndex);
   // this.props.getData();
 
    }


    onUPCChange(e) {
        this.setState({ codes: e.target.value });
    }

    onISRCChange(e) {
        this.setState({ isrcs: e.target.value });
    } 

    selectListType(data) {

        this.setState(
            { selectedOption : data });

    }

    setTerritoriesUpdate(e, selection) {
        var array = e.split(" ");       
        this.props.setTerritoriesUPCs(array,selection);
    }


render() {
    const access = localStorage.getItem("accessToken");    
    let url = this.props ? this.props.audioURL : '';
    const options = [
        { value: 'world', label: 'World' },
        { value: 'pd', label: 'PD' },
        { value: 'pdIndia', label: 'PD + India' },
        { value: 'worldExcCAUSACH', label: 'WW excl: Canada, China, USA' },
        { value: 'EuAUNZ', label: 'Europe, Australia and New Zealand' },
        { value: 'WWexEuAuNZUsCH', label: 'WW exc Europe, Australia, New Zealand, US, Canada, China' },
        { value: "WWexEuAuNz", label: "WW exc Europe, Australia, New Zealand" },
        { value: "pdIndiaAustraliaNZ", label: "PD + India + Australia + New Zealand" },
        { value: "wwexcUSAChinaCanadaPD", label: " WW ex USA, Canada, China, PD territories" },
        { value: "wwexcusaCanadaChinaPDIndia", label: "WW ex USA, Canada, China, PD territories + India" },
        { value: "pdExcCanadaChina", label: "PD exc Canada and China" },
        { value: "worldExcCAUSA", label:"WW ex USA, Canada"}

        
    ];
    const { selectedOption } = this.state;

    
    

    return (
        <div>              
                <h1>Territories Update</h1>

            <p>{this.props.territoriesUPCS.length} territories left to update </p>
            <p>{this.props.territoriesUPCS.length > 0 ? "Updating " + this.props.requestedTerritoryUPC + " to " + selectedOption.label : ""}</p>
            <p>{this.props.territoriesUPCS.length > 0 ? "(please don't reload or close the tab)" : ""}</p>
          
                <div className="row">
                <div className="col-sm-6">
                    <input type="text" disabled={this.props.isSavingTerritory || this.props.territoriesUPCS.length > 0} className="form-control" id="shortlistISRC" placeholder={"UPCS to Update"} onChange={(e) => this.onUPCChange(e)} value={this.state.codes} ></input>
                </div>
                <div className="col-sm-3">
                    <Select
                        isLoading={this.props.isLoadingUPCList}
                        name="form-field-name"
                        value={selectedOption}
                        options={options}
                        multi={false}
                        onChange={(data) => this.selectListType(data)}
                        disabled={this.props.isSavingTerritory || this.props.territoriesUPCS.length > 0 }
                    /></div>
                <div className="col-sm-3">
                    <button disabled={this.state.codes === '' || this.props.isSavingTerritory || selectedOption === null || this.props.territoriesUPCS.length > 0} onClick={(e) => this.setTerritoriesUpdate(this.state.codes, selectedOption.value)}>Update</button></div>
            </div>

            <br />

          
            <br/>
                <div className="row">
                <div className="col-sm-12">
                    {this.props.territoryResults !== null && this.props.territoryResults.length > 0 ? <CSVLink separator=";" data={this.props.territoryResults} filename={selectedOption.value + "-List-Data.csv"} >Download CSV</CSVLink> : ""}
                    {this.props.territoryResults.length > 0 ? renderReactTable(this.props.territoryResults, this.props, this) : ""}
                    </div>
                </div>

            </div>
          
     
            
            
          

        
    );
}
}



function renderReactTable(data, props,main) {

    console.info(main.state.filtered);

    const getColumns = () => {
        return Object.keys(data[0]).map(key => {
            return {
                Header: key,
                accessor: key
            };
        });
    }
    const onRowClick = (state, rowInfo, column, instance) => {
        if (typeof rowInfo !== "undefined") {
            return {
              
                style: {
                    background: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? '#00afec' : 'white',
                    color: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? 'white' : 'black',
                    
                }
            }
        } else {
            return {
                onClick: (e, handleOriginal) => {
                    if (handleOriginal) {
                        handleOriginal()
                    }
                }
            }
        }
    }
    return (
        <ReactTable
            getTrProps={onRowClick}
            data={data}
            filterable
            filtered={main.state.filtered}
            onFilteredChange={(filtered, column, value) => {
                main.onFilteredChangeCustom(value, column.id || column.accessor);
            }}
          
            defaultFilterMethod={(filter, row, column) => {
                const id = filter.pivotId || filter.id;                
                if (typeof filter.value === "object") {                    
                    return row[id] !== undefined || row[id] !==  null
                        ? filter.value.indexOf(row[id]) > -1
                        : true;
                } else {
                    return row[id] !== undefined
                        ? String(row[id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        : true;
                }
            }}

              
            columns={getColumns()}
            defaultSorted={[
                {
                    id: "name",
                    desc: true
                }
            ]}
            defaultPageSize={50}
            style={{
                height: "600px" // This will force the table body to overflow and scroll, since there is not enough room
            }}
            className="-striped -highlight"
        />)
};





export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Territories);



// WEBPACK FOOTER //
// ./src/components/Territories.js